export default {
      id: "measurements-usage",
      viewBox: "0 0 30.88 30.882",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#measurements",
      toString: function () {
        return this.url;
      }
    }